import { Table, Text } from '@mantine/core';

import { useArchiveServiceType } from '../../api/archiveServiceType';
import { useRestoreServiceType } from '../../api/restoreServiceType';
import { dictionaryTypes } from '../../types';
import { ArchiveToggle } from '../ArchiveToggle';

type Props = {
  serviceType: dictionaryTypes.ServiceType;
};

export const ServiceTypesRow = ({ serviceType }: Props) => {
  const archive = useArchiveServiceType();
  const restore = useRestoreServiceType();

  const isArchived = Boolean(serviceType.archivedAt);

  return (
    <Table.Tr>
      <Table.Td>
        <Text size="sm">{serviceType.text}</Text>
      </Table.Td>
      <Table.Td>
        <ArchiveToggle
          isArchived={isArchived}
          isLoading={isArchived ? restore.isLoading : archive.isLoading}
          onArchive={() => archive.mutate({ _id: serviceType._id })}
          onRestore={() => restore.mutate({ _id: serviceType._id })}
        />
      </Table.Td>
    </Table.Tr>
  );
};
